import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { InvoiceCompany } from '../../models/invoice-company.model';
import { GetSurveysFilters, Survey } from '../../models/invoice-survey.model';
import type {
  DownloadReportParams,
  DownloadReportType,
  RegenerateParams,
} from '../../models/invoice-download.model';

export const InvoiceActions = createActionGroup({
  source: 'Invoice',
  events: {
    'Search Surveys': props<{ filters: GetSurveysFilters; page: number }>(),
    'Search Surveys Success': props<{ surveys: Survey[] }>(),
    'Search Surveys Failure': props<{ error: string }>(),
    'Load Next Page': emptyProps(),
    'Load Companies': emptyProps(),
    'Load Companies Success': props<{ companies: InvoiceCompany[] }>(),
    'Load Companies Failure': props<{ error: string }>(),
    'Download Report': props<{
      downloadType: DownloadReportType;
      params: DownloadReportParams;
    }>(),
    'Download Report Success': props<{ downloadType: DownloadReportType }>(),
    'Download Report Failure': props<{
      downloadType: DownloadReportType;
      error: string;
    }>(),
    'Regenerate Invoice': props<{ params: RegenerateParams }>(),
    'Regenerate Invoice Success': props<{ message: string }>(),
    'Regenerate Invoice Failure': props<{ error: string }>(),
  },
});
